import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import Spinner from '@atlaskit/spinner';

export const ScrollingLoader = () => {
	return (
		<Box xcss={spinnerWrapperStyles}>
			<Spinner />
		</Box>
	);
};

const spinnerWrapperStyles = xcss({
	display: 'grid',
	justifyContent: 'center',
	margin: 'space.150',
});
